import classNames from 'classnames';
import styles from './DepositSelectSumSport.module.scss';
import { useState, useCallback } from 'react';

import { EBaseTextSize, EBaseTextWeight } from '@spinwise/react-component-library/BaseText';
import { ButtonLibrary } from 'Libraries/buttons.library';
import { Trans } from 'react-i18next';
import { IDepositSelectSum } from '../types';
import DepositInput from '../DepositInput/DepositInput';
import { ButtonGuardText } from '@spinwise/react-component-library/ButtonGuardText';
import {
  EBaseButtonSize,
  EBaseButtonTypeAttribute,
  EButtonBorderRadiusStrength,
  EButtonTextAlign,
} from '@spinwise/react-component-library/ButtonAbstract';
import { EGuardAnimations } from '@spinwise/react-component-library/ButtonCommon';
import { ButtonTextOnly } from '@spinwise/react-component-library/ButtonTextOnly';

const DepositSelectSumSport = ({
  MIN_DEP_AMOUNT,
  selectedValue,
  sumArray,
  setSelectedValue,
  onAmountSelected,
  onClickButton,
  onClickMobileInput,
  typeLabel,
}: IDepositSelectSum) => {
  const [playAnim, setPlayAnim] = useState('');
  const [beforeFirstInput, setBeforeFirstInput] = useState(true);

  const minDepAmount = (
    <Trans components={{ MIN_DEP_AMOUNT: <span>{MIN_DEP_AMOUNT}</span> }} transKeepBasicHtmlNodesFor>
      {'warning.min.dep.amount'}
    </Trans>
  ) as any;
  const amountAsFloat = parseFloat(selectedValue?.toString()) || 0;

  const handleAmountSelected = useCallback(
    (value: string) => {
      onAmountSelected(value);
    },
    [onAmountSelected],
  );

  const handleClickMobileInput = useCallback(() => {
    onClickMobileInput();
  }, [onClickMobileInput]);

  const handleSetPlayAnim = useCallback((value: string) => {
    setPlayAnim(value);
  }, []);

  const handleSetBeforeFirstInput = useCallback((value: boolean) => {
    setBeforeFirstInput(value);
  }, []);

  const handleSetSelectedValue = useCallback(
    (value: number) => {
      setSelectedValue(value);
    },
    [setSelectedValue],
  );

  return (
    <>
      <div className={`${styles.deposit_container} jc-fs ai-c fl-d-c`}>
        <div className={styles.deposit_container__wrapper}>
          <DepositInput
            selectedValue={selectedValue}
            minDepAmount={MIN_DEP_AMOUNT}
            onAmountSelected={handleAmountSelected}
            onClickMobileInput={handleClickMobileInput}
            playAnim={playAnim}
            setPlayAnim={handleSetPlayAnim}
            setSelectedValue={handleSetSelectedValue}
            setBeforeFirstInput={handleSetBeforeFirstInput}
            beforeFirstInput={beforeFirstInput}
          />
          {sumArray &&
            sumArray.length > 0 &&
            sumArray.map((sum, index) => (
              <div
                key={sum}
                onClick={() => {
                  if (beforeFirstInput) setBeforeFirstInput(false);
                  handleAmountSelected(sum.toString());
                  handleSetPlayAnim('');
                }}
                className={classNames(
                  styles.deposit_container__wrapper_btn,
                  styles?.[`deposit_container__wrapper_btn__${index}`],
                  {
                    [`${styles.deposit_container__wrapper_btn__selected}`]: selectedValue === sum,
                  },
                )}
              >
                <p>{`€${sum}`}</p>
              </div>
            ))}
        </div>

        <div className={`d-fl jc-sb ai-c fl-d-c ${styles.deposit_container__sum}`}>
          <div className="w-100">
            {selectedValue === null || amountAsFloat < MIN_DEP_AMOUNT ? (
              <ButtonGuardText
                label={typeLabel}
                size={EBaseButtonSize.Small}
                type={ButtonLibrary.Tertiary}
                borderRadius={EButtonBorderRadiusStrength.Eight}
                typeAttribute={EBaseButtonTypeAttribute.Submit}
                fullWidth={true}
                alignText={EButtonTextAlign.Center}
                textSize={EBaseTextSize.Large}
                textWeight={EBaseTextWeight.W500}
                guardText={{
                  value: minDepAmount,
                  size: EBaseTextSize.Large,
                  weight: EBaseTextWeight.W500,
                }}
                guardAnimation={EGuardAnimations.UpDown}
                onGuardAnimationEnd={() => {
                  handleSetSelectedValue(MIN_DEP_AMOUNT);
                  handleSetPlayAnim('');
                }}
                onClick={() => {
                  handleSetPlayAnim(styles.play_anim);
                }}
              />
            ) : (
              <ButtonTextOnly
                label={typeLabel}
                size={EBaseButtonSize.Small}
                textWeight={EBaseTextWeight.W500}
                textSize={EBaseTextSize.Large}
                type={ButtonLibrary.Tertiary}
                borderRadius={EButtonBorderRadiusStrength.Eight}
                typeAttribute={EBaseButtonTypeAttribute.Submit}
                fullWidth={true}
                alignText={EButtonTextAlign.Center}
                onClick={() => {
                  onClickButton();
                }}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DepositSelectSumSport;
